import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { attachmentService } from '../../services/api'
import { Attachment } from '../../models/Attachment.model'

const initialState = {
  attachments: {},
  loading: false,
  error: null,
  uploadProgress: 0
}

export const uploadAttachment = createAsyncThunk(
  'attachments/uploadAttachment',
  async ({ file, type }, { rejectWithValue }) => {
    try {
      const response = await attachmentService.upload(file, type)
      return Attachment.FromObj(response.data)
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to upload attachment')
    }
  }
)

export const deleteAttachment = createAsyncThunk(
  'attachments/deleteAttachment',
  async (attachmentId, { rejectWithValue }) => {
    try {
      await attachmentService.delete(attachmentId)
      return attachmentId
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete attachment')
    }
  }
)

const attachmentsSlice = createSlice({
  name: 'attachments',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadAttachment.pending, (state) => {
        state.loading = true
        state.error = null
        state.uploadProgress = 0
      })
      .addCase(uploadAttachment.fulfilled, (state, action) => {
        state.loading = false
        state.attachments[action.payload.id] = action.payload
        state.uploadProgress = 100
      })
      .addCase(uploadAttachment.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.uploadProgress = 0
      })
      
      .addCase(deleteAttachment.fulfilled, (state, action) => {
        delete state.attachments[action.payload]
      })
  }
})

export const { clearError, setUploadProgress } = attachmentsSlice.actions
export const selectAttachments = (state) => state.attachments.attachments
export const selectAttachmentsLoading = (state) => state.attachments.loading
export const selectAttachmentsError = (state) => state.attachments.error
export const selectUploadProgress = (state) => state.attachments.uploadProgress

export default attachmentsSlice.reducer 